// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layer-details-feature-title {\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.layer-details-title {\n    margin-top:25px;\n    font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
